/**
 * Partner Types
 */
import { createTypes } from "../NTICore/CommonFunctions/ReduxHelper";

//Using ASYNC as a convention to know that I'll have three types.
export const CREATE_PARTNER_AGREEMENT = createTypes(
  "AGREEMENT/CREATE_PARTNER_AGREEMENT"
);
export const DOWNLOAD_AGREEMENT = createTypes("AGREEMENT/DOWNLOAD_AGREEMENT");
export const SET_PARTNER_AGREEMENT = createTypes(
  "AGREEMENT/SET_PARTNER_AGREEMENT"
);
export const SET_COMMITMENT = createTypes(
  "AGREEMENT/SET_COMMITMENT"
);
export const SEND_MESSAGE_TO_PARTNER = createTypes(
  "AGREEMENT/SEND_MESSAGE_TO_PARTNER"
);
export const SEND_MESSAGE_TO_INTERNAL_CEO = createTypes(
  "AGREEMENT/SEND_MESSAGE_TO_INTERNAL_CEO"
);


// TODO: ROUTES TYPES
export const SUCCESS_FORM = createTypes("AGREEMENT/SUCCESS_FORM");
export const GO_TO_COMMITMENT_PAGE = createTypes(
  "COMMITMENT/GO_TO_COMMITMENT_PAGE"
);



// WEBPACK FOOTER //
// ./src/modules/PartnerAgreement/types.js